export default __webpack_public_path__ + "static/migation-tranformation-838e6a61fb0851f761a8f8c120fa5e37.png";